<template>
  <div class="columns is-multiline is-marginless is-main-content is-paddingless"
       v-if="critereRecherche">
    <div class="column is-12 pdb-0 hauteur-haut-brief-filtre">
      <div class="column is-12 mgt-5px">
        <a @click="$emit('toggleFiltre')">
          <b-icon class="icon is-pulled-right has-text-icon-more" icon="close"></b-icon>
        </a>
        <span class="has-text-weight-bold is-size-4">
          {{ $t('listeDemande.filtre.title') }}
        </span>
      </div>
      <div class="column is-12 pdt-0">
        <span class="has-text-icon-more is-size-7">
          {{ $t('listeDemande.filtre.sousTitle') }}
        </span>
      </div>
    </div>
    <div class="column is-12 is-marginless overflow-auto hauteur-brief-filtre">
      <div class="column is-12 pdb-0"
        v-if="type === constantes.TYPE_DEMANDE_AUTO">
        <b-field :label="$t('listeDemande.filtre.jourDepart')">
          <qd-taginput v-model="jourDepartSelected"
                      :data="filteredJourDepartTags"
                      autocomplete
                      open-on-focus
                      field="libelle"
                      type="is-primary"
                      icon="magnify"
                      @typing="getFilteredJourDepartTags"
                      @input="getTypeJourDepartTags">
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 is-marginless pdb-0"
        v-if="type === constantes.TYPE_DEMANDE_AUTO">
        <b-field :label="$t('listeDemande.filtre.reseau')">
          <qd-taginput
            v-model="reseauSelected"
            icon="magnify"
            :data="filteredReseau"
            autocomplete
            type="is-primary"
            :loading="isFetching"
            field="libelle"
            @typing="getFilteredReseau">
            <template slot="empty">
              <div v-if="!isFetching">
                {{$t('listeDemande.filtre.actions.noResult')}}
              </div>
              <div v-else>{{$t('listeDemande.filtre.actions.search')}}</div>
            </template>
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 is-marginless pdb-0"
        v-if="type === constantes.TYPE_DEMANDE_LOGISTIQUE">
        <b-field :label="$t('listeDemande.filtre.produit')">
          <qd-taginput
            v-model="produitSelected"
            icon="magnify"
            :data="filteredProduit"
            autocomplete
            type="is-primary"
            :loading="isFetching"
            field="libelle"
            @typing="getFilteredProduit">
            <template slot="empty">
              <div v-if="!isFetching">
                {{$t('listeDemande.filtre.actions.noResult')}}
              </div>
              <div v-else>{{$t('listeDemande.filtre.actions.search')}}</div>
            </template>
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <libelle-tag-input
                      :label="$t('listeDemande.filtre.nature')"
                      :items="allTagsCategorieVente"
                      v-model="typesProduitsSelected">
        </libelle-tag-input>
      </div>
    </div>
    <div class="column is-12 border-pied pdt-0 hauteur-bas-brief-filtre">
      <button
        class="button mgl-10px mgt-10px is-addOrEdit has-text-white"
        @click="appliquerCritere()">
        {{$t('listeDemande.filtre.actions.appliquer')}}
      </button>

      <button
        class="button border-none mgt-10px has-text-icon-more pd-10px"
        @click="viderCritere()">
        {{$t('listeDemande.filtre.actions.reinitialiser')}}
      </button>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import debounce from 'lodash/debounce';
import * as genererCritereRecherche from '@/services/logistique/demande/genererCritereRechercheDemande';
import { SET_CRITERE, SET_CRITERE_LOGISTIQUE } from '@/store/modules/logistique/demande-mutation-type';
import { LISTE_INDEX_JOURS } from '@/configuration/datePickerConf';
import { CATEGORIE_REGROUPEMENT_MAIRIE } from '@/configuration/catalogue/produitConf';
import ucFirst from '@/services/general/ucFirst';
import { getAll } from '@/api/produit/produitReseau';
import { getAll as getAllProduit } from '@/api/produit/index';
import * as demandeConf from '@/configuration/logistique/demande/demandeConf';
import * as produitConf from '@/configuration/catalogue/produitConf';
import libelleTagInput from '@/components/general/tagInput/libelleTagInput';

const Demande = createNamespacedHelpers('demande');

export default {
  data() {
    return {
      critereRecherche: null,
      filteredJourDepartTags: null,
      jourDepartSelected: [],
      reseauSelected: [],
      filteredReseau: [],
      produitSelected: [],
      typesProduitsSelected: [],
      filteredProduit: [],
      isFetching: false,
      constantes: {
        TYPE_DEMANDE_AUTO: demandeConf.TYPE_DEMANDE_AUTO,
        TYPE_DEMANDE_LOGISTIQUE: demandeConf.TYPE_DEMANDE_LOGISTIQUE,
      },
    };
  },
  props: {
    type: {
      type: String,
      required: true,
    },
  },
  components: {
    libelleTagInput,
  },
  computed: {
    ...Demande.mapGetters({
      critereRechercheAuto: 'criteresRecherche',
      critereRechercheLogistique: 'criteresRechercheLogistique',
    }),
    allTagsCategorieVente() {
      const liste = demandeConf.CATEGORIE_PRODUIT_LOGISTIQUE;
      return liste.filter(type => type.code !== CATEGORIE_REGROUPEMENT_MAIRIE);
    },
    critereRechercheFromStore() {
      switch (this.type) {
        case this.constantes.TYPE_DEMANDE_AUTO: return this.critereRechercheAuto;
        case this.constantes.TYPE_DEMANDE_LOGISTIQUE: return this.critereRechercheLogistique;
        default: return null;
      }
    },
    getListeJourDepart() {
      const listeJour = cloneDeep(LISTE_INDEX_JOURS);
      listeJour.forEach((jour) => {
        jour.libelle = ucFirst(jour.libelle);
      });
      return listeJour;
    },
  },
  methods: {
    ...Demande.mapMutations({
      setCritereRechercheAuto: SET_CRITERE,
      setCritereRechercheLogistique: SET_CRITERE_LOGISTIQUE,
    }),
    getTypeJourDepartTags() {
      this.filteredJourDepartTags = this.getListeJourDepart.filter((option) => {
        return !this.jourDepartSelected.map(c => c.number).includes(option.number);
      });
    },
    getFilteredJourDepartTags(text) {
      this.getTypeJourDepartTags();
      this.filteredJourDepartTags = this.filteredJourDepartTags.filter((option) => {
        return option.libelle.toString().toLowerCase().indexOf(text.toLowerCase()) >= 0;
      });
    },
    getFilteredReseau: debounce(async function getProduitReseau(text) {
      if (!text) return;
      this.isFetching = true;
      const produitsReseau = (await getAll({ query: { auto: text } })).data.result.items;
      this.filteredReseau = produitsReseau.filter((produitReseau) => {
        return !this.reseauSelected.map(reseau => reseau.id).includes(produitReseau.id);
      });
      this.isFetching = false;
    }, 300),
    getFilteredProduit: debounce(async function getProduitReseau(text) {
      if (!text) return;
      this.isFetching = true;
      const produits = (await getAllProduit({
        query: {
          auto: text,
          categorie: [produitConf.CATEGORIE_REGROUPEMENT, produitConf.CATEGORIE_UNITAIRE],
        },
      })).data.result.items;
      this.filteredProduit = produits.filter((produitReseau) => {
        return !this.produitSelected.map(produit => produit.id).includes(produitReseau.id);
      });
      this.isFetching = false;
    }, 300),
    viderCritere() {
      switch (this.type) {
        case this.constantes.TYPE_DEMANDE_AUTO:
          this.critereRecherche = genererCritereRecherche.genererCritereRechercheDemande();
          break;
        case this.constantes.TYPE_DEMANDE_LOGISTIQUE:
          this.critereRecherche = genererCritereRecherche
            .genererCritereRechercheDemandesLogistiques();
          break;
        default:
          this.critereRecherche = {};
          break;
      }
      this.jourDepartSelected = [];
      this.typesProduitsSelected = [];
      this.reseauSelected = [];
      this.produitSelected = [];
      this.getTypeJourDepartTags();
    },
    appliquerCritere() {
      this.critereRecherche.jourDepart = this.jourDepartSelected.map((jourDepart) => {
        return jourDepart.number;
      });
      this.critereRecherche.reseau = cloneDeep(this.reseauSelected);
      this.critereRecherche.produits = cloneDeep(this.produitSelected);
      this.critereRecherche.typesProduits = this.typesProduitsSelected.map((type) => {
        return type.code;
      });
      switch (this.type) {
        case this.constantes.TYPE_DEMANDE_AUTO:
          this.setCritereRechercheAuto(this.critereRecherche);
          break;
        case this.constantes.TYPE_DEMANDE_LOGISTIQUE:
          this.setCritereRechercheLogistique(this.critereRecherche);
          break;
        default: break;
      }
      this.$emit('close');
    },
    initializeFiltre() {
      this.critereRecherche = cloneDeep(this.critereRechercheFromStore);
      if (this.critereRecherche.jourDepart) {
        this.jourDepartSelected = this.getListeJourDepart.filter((option) => {
          return this.critereRecherche.jourDepart.includes(option.number);
        });
      }
      if (this.critereRecherche.reseau) {
        this.reseauSelected = cloneDeep(this.critereRecherche.reseau);
      }
      if (this.critereRecherche.typesProduits) {
        this.typesProduitsSelected = demandeConf.CATEGORIE_PRODUIT_LOGISTIQUE.filter((type) => {
          return this.critereRecherche.typesProduits.includes(type.code);
        });
      }
      if (this.critereRecherche.produits) {
        this.produitSelected = cloneDeep(this.critereRecherche.produits);
      }
      this.getTypeJourDepartTags();
    },
  },
  mounted() {
    this.initializeFiltre();
  },
};
</script>
